import React, { Component, PropTypes } from 'react';
import Gallery from 'react-photo-gallery';
import Lightbox from 'react-images';


const photos = [
  { src: '../assets/images/center/1.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/2.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/3.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/4.jpg', width: 3, height: 4 },
  { src: '../assets/images/center/6.jpg', width: 3, height: 4 },
  { src: '../assets/images/center/7.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/8.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/9.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/10.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/11.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/12.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/13.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/14.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/15.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/16.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/17.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/18.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/19.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/20.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/21.jpg', width: 4, height: 3 },
  { src: '../assets/images/center/22.jpg', width: 4, height: 3 },
];

export default class Christmas extends Component {
  constructor(props) {
    super(props)
    this.state = { currentImage: 0 };
    this.closeLightbox = this.closeLightbox.bind(this);
    this.openLightbox = this.openLightbox.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);
  }

  openLightbox(event, obj) {
    this.setState({
      currentImage: obj.index,
      lightboxIsOpen: true,
    });
  }
  closeLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
    });
  }
  gotoPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  }
  gotoNext() {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  }

  render() {

    return (
      <div className="col-sm-12">
        <h3>Craciunei si craciunite</h3>
        <section className="category cc-articles">

          <div className="i" id="articles">
            {/* <h2 className="category__title category__title--lozenge"><span className="category__title__text">Centrul de recuperare</span></h2> */}
            <div className="item item--issue item--link">
              <p className="text-justify">
              Sprijin lunar pentru activităţile noastre avem din partea grupului de facebook Crăciunei şi Crăciuniţe. Fiecare membru al grupului donează lunar  minim 20 lei/5 euro, bani cu care reuşim  să asigurăm alimentele de bază la toţi copiii.<br/>
              Cei care doresc să se alăture nouă o pot face căutȃnd grupul pe facebook şi  acţionȃnd butonul “Inscrie-te in grup”. Banii se pot depune lunar ȋn conturile asociaţiei, sau pe mai multe luni o dată.<br/>
              Momentan  avem peste 250 de Crăciunei şi Crăciuniţe.
              </p>

              <p>
                Activitatea noastră o puteți urmari pe facebook în cadrul grupului creat pentru a-o putea face vizibilă, adresa grupului fiind urmatoarea:<br/>
                <a href="https://www.facebook.com/groups/1720460764852325/"> Crăciunei şi Crăciuniţe</a>
                </p>
            </div>
          </div>
          {/* <div className="item item--issue item--link">
            <Gallery photos={photos} onClick={this.openLightbox} />
            <Lightbox images={photos}
              onClose={this.closeLightbox}
              onClickPrev={this.gotoPrevious}
              onClickNext={this.gotoNext}
              currentImage={this.state.currentImage}
              isOpen={this.state.lightboxIsOpen}
            />
          </div> */}
        </section>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./app/screens/Christmas/christmas.js